import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CarrierId } from '../../shipping-config-v2.service';

@Component({
  selector: 'app-rate-option-v2',
  templateUrl: './rate-option-v2.component.html',
  styleUrls: ['./rate-option-v2.component.scss'],
})
export class RateOptionV2Component {
  @Input() id = '';
  @Input() carrier: CarrierId = 'ups';
  @Input() service = '';
  @Input() eta = '';
  @Input() price = 0;
  @Input() suggested = false;
  @Input() selected = false;
  @Output() selectRate = new EventEmitter<string>();
}
